import React, { useState } from 'react';
import { Link2, Check, Share2, MessageCircle, Send } from 'lucide-react';
import { toast } from 'sonner';

export function lessonShareUrl(courseId: string, lessonId: string): string {
  return `${window.location.origin}/member/courses/${courseId}/lessons/${lessonId}`;
}

interface Props {
  courseId: string;
  lessonId: string;
  title: string;
  compact?: boolean;
}

export function ShareLesson({ courseId, lessonId, title, compact }: Props) {
  const [copied, setCopied] = useState(false);
  const url = lessonShareUrl(courseId, lessonId);
  const text = `Materi "${title}" di Cuantrader: ${url}`;

  const copy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const el = document.createElement('textarea');
      el.value = url;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
    setCopied(true);
    toast.success('Link materi disalin');
    setTimeout(() => setCopied(false), 2000);
  };

  const stop = (e: React.MouseEvent) => e.stopPropagation();
  const btn = `flex items-center justify-center gap-1.5 rounded-lg border border-white/10 bg-white/5 text-white/70 hover:text-cyan-400 hover:bg-white/10 transition-colors ${
    compact ? 'p-2' : 'px-3 py-2 text-xs'
  }`;

  return (
    <div className="flex items-center gap-1.5" onClick={stop}>
      <button data-testid="share-lesson-copy" onClick={copy} className={btn} title="Copy link materi">
        {copied ? <Check className="w-4 h-4 text-emerald-400" strokeWidth={2} /> : <Link2 className="w-4 h-4" strokeWidth={1.8} />}
        {!compact && <span>{copied ? 'Tersalin' : 'Copy Link'}</span>}
      </button>
      <a
        data-testid="share-lesson-whatsapp"
        href={`https://wa.me/?text=${encodeURIComponent(text)}`}
        target="_blank"
        rel="noreferrer"
        onClick={stop}
        className={btn}
        title="Bagikan ke WhatsApp"
      >
        <MessageCircle className="w-4 h-4" strokeWidth={1.8} />
        {!compact && <span>WhatsApp</span>}
      </a>
      <a
        data-testid="share-lesson-telegram"
        href={`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(`Materi "${title}" di Cuantrader`)}`}
        target="_blank"
        rel="noreferrer"
        onClick={stop}
        className={btn}
        title="Bagikan ke Telegram"
      >
        <Send className="w-4 h-4" strokeWidth={1.8} />
        {!compact && <span>Telegram</span>}
      </a>
      {!compact && <Share2 className="w-3.5 h-3.5 text-white/20 ml-1" strokeWidth={1.5} />}
    </div>
  );
}
